// Auto-generated — do not edit
import { i18nBundle } from '@amzn/amp-i18n'
import type { HeaderGetString, HeaderGetStringAsync } from './types.generated'

const headerLocales = [
    'en-US',
    'bn-IN',
    'cs-CZ',
    'de-DE',
    'en-AU',
    'en-CA',
    'en-GB',
    'en-IN',
    'es-ES',
    'es-MX',
    'es-US',
    'fr-CA',
    'fr-FR',
    'hi-IN',
    'it-IT',
    'ja-JP',
    'kn-IN',
    'ml-IN',
    'mr-IN',
    'nl-NL',
    'pa-IN',
    'pl-PL',
    'pt-BR',
    'ta-IN',
    'te-IN',
    'tr-TR',
    'zh-CN',
] as const
const headerBundle = i18nBundle('header/header', headerLocales)

export const getString: HeaderGetString = headerBundle.getString
export const getStringAsync: HeaderGetStringAsync = headerBundle.getStringAsync
